import * as React from 'react'

import * as styles from './badge.module.css'

interface IProps {
  children: React.ReactNode
}

const Badge = ({ children }: IProps) => (
  <span className={styles.root}>{children}</span>
)

export default Badge
